import { z } from 'zod';
import { templateBaseSchema } from './base';

export const templateSeparatorSchema = templateBaseSchema.extend({
  type: z.literal('separator'),
  style: z.enum(['solid', 'dashed']),
  color: z.enum(['black', 'gray']),
});

export type TemplateSeparatorV1 = z.infer<typeof templateSeparatorSchema>;
